module.exports = __webpack_public_path__ + "media/assets/img/company/Logo paris 2-c6423785dcd0ae7634e7d53e5db1ad65.png";